import React from 'react'
import { useIntl } from 'react-intl'
import { getTranslation } from '@/utilities/formatter'

import Loading from '@/views/components/Loading'

import { GetAssociationsForFrontendQuery } from '@/packages/associations/gql/Associations.generated'

export default function AssociationsOverview({
  dataAssociations,
  loading,
}: {
  dataAssociations: GetAssociationsForFrontendQuery | undefined
  loading: boolean
}) {
  const intl = useIntl()

  return (
    <div className='association-overview-wrapper'>
      {/* kantonale vereinigungen */}
      <div className="association-row">
        <span>
          <strong>
            {intl.formatMessage({
              id: 'associations.titles.cantonal',
              defaultMessage: 'Cantonal associations'
            })}
          </strong>
        </span>
        <span>
          <strong>
            {intl.formatMessage({
              id: 'associations.titles.president',
              defaultMessage: 'President'
            })}
          </strong>
        </span>
        <span>
          <strong>
            {intl.formatMessage({
              id: 'associations.titles.email',
              defaultMessage: 'E-Mail'
            })}
          </strong>
        </span>
        <span></span>
      </div>
      {loading ? <Loading /> : null}
      {dataAssociations?.getAssociationsForFrontend.sort(
        (a, b) => (a.association.billingInformation?.canton || '').localeCompare(b.association.billingInformation?.canton || '')
      ).filter(a => !a.association.isStufenvereinigung).map((association) => (
        <div key={association.association.id} className='association-row'>
          <span className="association-name">
            <span>
              {association.association.billingInformation?.canton}
            </span>
            {association.association.associationURL && (
              <a
                href={association.association.associationURL}
                target='_blank'
                rel='noreferrer'
              >
                {getTranslation(association.association.short, intl)}
              </a>
            )}
            {!association.association.associationURL && (
              <span>
                {getTranslation(association.association.short, intl)}
              </span>
            )}
          </span>
          <span>
            {association.presidents?.map((president, index) => (
              <div key={index} className="president">
                <span>
                  {president.name || ''}
                </span>
                <span>
                  {president.email && (
                    <a href={'mailto:' + president.email}>
                      {intl.formatMessage({
                        id: 'associations.titles.email',
                        defaultMessage: 'E-Mail'
                      })}
                    </a>
                  )}
                </span>
              </div>
            ))}
          </span>
          <span className="img-wrapper">
            {association.association.imageSrc && (
              <img src={association.association.imageSrc} alt={association.association.name.de} />
            )}
          </span>
        </div>
      ))}
      {/* stufenvereinigungen */}
      <div className="association-row stufenvereinigung">
        <span>
          <strong>
            {intl.formatMessage({
              id: 'associations.titles.sectional',
              defaultMessage: 'Sectional associations'
            })}
          </strong>
        </span>
        <span>
          <strong>
            {intl.formatMessage({
              id: 'associations.titles.president',
              defaultMessage: 'President'
            })}
          </strong>
        </span>
        <span>
          <strong>
            {intl.formatMessage({
              id: 'associations.titles.email',
              defaultMessage: 'E-Mail'
            })}
          </strong>
        </span>
        <span></span>
      </div>
      {loading ? <Loading /> : null}
      {dataAssociations?.getAssociationsForFrontend.sort(
        (a, b) => (a.association.billingInformation?.canton || '').localeCompare(b.association.billingInformation?.canton || '')
      ).filter(a => a.association.isStufenvereinigung).map((association) => (
        <div key={association.association.id} className='association-row'>
          <span className="association-name">
            {association.association.associationURL && (
              <a
                href={association.association.associationURL}
                target='_blank'
                rel='noreferrer'
              >
                {getTranslation(association.association.short, intl)}
              </a>
            )}
            {!association.association.associationURL && (
              <span>
                {getTranslation(association.association.short, intl)}
              </span>
            )}
          </span>
          <span>
            {association.presidents?.map((president, index) => (
              <div key={index} className="president">
                <span>
                  {president.name || ''}
                </span>
                <span>
                  {president.email && (
                    <a href={'mailto:' + president.email}>
                      {intl.formatMessage({
                        id: 'associations.titles.email',
                        defaultMessage: 'E-Mail'
                      })}
                    </a>
                  )}
                </span>
              </div>
            ))}
          </span>
          <span className="img-wrapper">
            {association.association.imageSrc && (
              <img src={association.association.imageSrc} alt={association.association.name.de} />
            )}
          </span>
        </div>
      ))}
    </div>
  )
}
